var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Spinner } from '@fluentui/react-components';
import AppHostComponent, { logAppHostMetrics, logAppHostMetricsWithMsgDelay, } from '@office-start/app-host-component';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { useCurrentRoute, useOfficeComponentContext, } from '@office-start/component-context-service';
import { CopilotFreStatus, isCopilotPinned, useCopilotUserAdminSetting, useHideTUI, usePinCopilotToAppBar, useShowCopilotTUI, useUserCopilotFreData, } from '@office-start/copilot-fre-service';
import { CopilotRedirectionQueryParams, FreNotShownReasons, logCopilotFunnelEvent, } from '@office-start/copilot-fre-telemetry-service';
import { useBCAIS, useCopilotEligibilityReasons, useCopilotEligible, usePinningEligible, useStandaloneCopilotApp, } from '@office-start/copilot-route-service';
import { CopilotAdminPinningStatus, CopilotUserPinningStatus, } from '@office-start/copilot-types';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useFeatureSettings } from '@office-start/feature-settings-service';
import { useIdentity } from '@office-start/identity-service';
import { useLocStrings } from '@office-start/loc-service';
import { copilotM365AppId } from '@office-start/m365-apps-service';
import { isMosRouteItem, OfficeRouteItemType, OfficeWorkload, } from '@office-start/officehome-types';
import { routeToCopilotStandalone, routeToOCDIChat, } from '@office-start/route-utility';
import { handleResumeScheduling } from '@office-start/scheduler-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import React, { createRef, lazy, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { withLazyErrorBoundary } from '../LazyFeature/withLazyErrorBoundary';
import { PageUnstyled } from '../Page/Page';
import { TeachingUiContainer } from '../TeachingUiContainer/TeachingUiContainer';
import { useStyles } from './CopilotAppPage.styles';
import { OCDIBannerAnnouncementWrapper } from './OCDIBannerAnnouncementWrapper';
var ComingSoonControlLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "coming-soon" */ '@office-start/coming-soon-component');
}), 'ComingSoonComponent');
var CopilotNotAvailableLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "copilot-not-supported" */ '@office-start/coming-soon-component').then(function (module) { return ({
        default: module.CopilotNotSupportedComponent,
    }); });
}), 'CopilotNotSupportedComponent');
var CopilotFreLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "copilot-fre" */ '@office-start/copilot-fre');
}), 'CopilotFre');
var MsaModeBComponentLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "msa-modeb" */ '@office-start/coming-soon-component').then(function (module) { return ({
        default: module.MsaModeBComponent,
    }); });
}), 'MSAModeBComponent');
export var appbarConnectorService = AppbarConnectorService.getInstance();
var Copilot_Throttling_Number_Key = 'Copilot_Throttling_Number';
var Copilot_Throttling_Timestamp_Key = 'Copilot_Throttling_Timestamp';
export var CopilotAppPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var identity = useIdentity().data;
    var userEntitlements = useUserEntitlements().data;
    var featureGates = useFeatureGates().data;
    var featureSettings = useFeatureSettings().data;
    var officeComponentContext = useOfficeComponentContext().data;
    var isCopilotPinnedToAppBar = usePinCopilotToAppBar().isPinned;
    var _3 = __read(useState(undefined), 2), isFreScreenVisible = _3[0], setIsFreScreenVisible = _3[1];
    var _4 = __read(useState(false), 2), isRedirectPending = _4[0], setIsRedirectPending = _4[1];
    var _5 = __read(useState(false), 2), isCopilotFreCompleted = _5[0], setIsCopilotFreCompleted = _5[1];
    var _6 = __read(useState(undefined), 2), throttleUser = _6[0], setThrottleUser = _6[1];
    var cmcBaseUrlDefault = 'https://copilot.microsoft.com/';
    var copilotBaseUrlccmRedirecttion = (_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.copilot) === null || _b === void 0 ? void 0 : _b.ccmRedirectionHost;
    var copilotBaseUrlm365Redirecttion = (_d = (_c = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _c === void 0 ? void 0 : _c.copilot) === null || _d === void 0 ? void 0 : _d.m365RedirectionHost;
    var isCopilotFreEnabled = (_e = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _e === void 0 ? void 0 : _e.copilotFreEnabled;
    var isCopilotFreContinueSkuEnabled = (_f = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _f === void 0 ? void 0 : _f.copilotFreContinueSkuEnabled;
    var loggedAppIdRef = useRef(null);
    var updatedCopilotRenderCounterOnce = useRef(false);
    var copilotFreDataFromOfficeContextEnabled = (_g = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.copilotFreGates) === null || _g === void 0 ? void 0 : _g.copilotFreDataFromOfficeContextEnabled;
    var _7 = useUserCopilotFreData(copilotFreDataFromOfficeContextEnabled), userCopilotFreData = _7.data, updateUserPinningData = _7.update;
    var _8 = __read(useState(''), 2), timeElapsedTillCopilotAppPageRender = _8[0], setTimeElapsedTillCopilotAppPageRender = _8[1];
    var _9 = __read(useState(false), 2), isOnCopilotAppPageRenderLogged = _9[0], setIsCopilotAppPageRenderLogged = _9[1];
    var _10 = __read(useState(false), 2), isOnNoCopilotFRERenderLogged = _10[0], setNoCopilotFRERenderLogged = _10[1];
    var isOnCopilotModeAComingSoonLoggedRef = useRef(false);
    var isOnCopilotModeBComingSoonLoggedRef = useRef(false);
    var _11 = useCopilotUserAdminSetting(), userSetting = _11.userSetting, adminSetting = _11.adminSetting;
    var styles = useStyles();
    var locStrings = useLocStrings().data;
    var showModeBExperience = ((_j = (_h = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _h === void 0 ? void 0 : _h.copilot) === null || _j === void 0 ? void 0 : _j.mode) === 'ModeB';
    var updateShowCopilotTUI = useShowCopilotTUI().updateShowCopilotTUI;
    var updateHideTUI = useHideTUI().updateHideTUI;
    var currentRoute = useCurrentRoute();
    var isStandaloneCopilotApp = useStandaloneCopilotApp();
    var _12 = __read(useState({
        appId: copilotM365AppId,
        route: 'M365Apps',
        type: OfficeRouteItemType.Mos,
    }), 2), routeItem = _12[0], setRouteItem = _12[1];
    var isBCAIS = useBCAIS();
    var isPinningEligible = usePinningEligible();
    var isEligibleForAnyCopilot = useCopilotEligible();
    var copilotEligibilityReasons = useCopilotEligibilityReasons();
    var userCopilotTabPinnedState = useMemo(function () {
        return isCopilotPinned(isBCAIS, isPinningEligible, isCopilotPinnedToAppBar);
    }, [isBCAIS, isCopilotPinnedToAppBar, isPinningEligible]);
    useEffect(function () {
        logAppHostMetrics({
            appId: copilotM365AppId,
            scenarioName: 'CopilotAppPageStart',
            clientTimeStamp: appbarConnectorService.userClickTime,
            tileChanged: appbarConnectorService.tileChanged,
            appUrl: window.location.pathname,
            appSearchParams: window.location.search,
            isStandaloneApp: isStandaloneCopilotApp,
            resourceDeliveryType: appbarConnectorService.resourceDeliveryType,
        });
    }, []);
    var isRoutedFromHwaAppsPage = useCallback(function () {
        return ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) === OfficeWorkload.Hwa &&
            appbarConnectorService.appUrl === '/apps/');
    }, [officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload]);
    var navigateToHomePage = useCallback(function () {
        officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.router.navigateTo({
            route: 'OfficeHome',
        });
    }, [officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.router]);
    useEffect(function () {
        var _a, _b, _c;
        if (isRoutedFromHwaAppsPage()) {
            // In Desktop app, if user opens copilot from app gallery, we need to allow opening the copilot in all the cases
            return;
        }
        if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) === OfficeWorkload.Hwa &&
            !isBCAIS &&
            !isPinningEligible) {
            // User is not eligible for copilot, directly land on desktop home page.
            navigateToHomePage();
        }
        if (!userCopilotTabPinnedState &&
            !((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.isStandaloneCopilotApp) &&
            (isCopilotFreCompleted ||
                (userCopilotFreData === null || userCopilotFreData === void 0 ? void 0 : userCopilotFreData.CopilotFreStatus) ===
                    CopilotFreStatus.Declined)) {
            if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) === OfficeWorkload.Hwa) {
                navigateToHomePage();
            }
            else if ((_c = (_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _b === void 0 ? void 0 : _b.copilotGates) === null || _c === void 0 ? void 0 : _c.copilotAppCCMRoutingEnabled) {
                setIsRedirectPending(routeToCopilotStandalone(isStandaloneCopilotApp, copilotBaseUrlccmRedirecttion, identity));
            }
        }
    }, [
        copilotBaseUrlccmRedirecttion,
        (_l = (_k = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _k === void 0 ? void 0 : _k.copilotGates) === null || _l === void 0 ? void 0 : _l.copilotAppCCMRoutingEnabled,
        identity,
        isCopilotFreCompleted,
        isStandaloneCopilotApp,
        userCopilotFreData === null || userCopilotFreData === void 0 ? void 0 : userCopilotFreData.CopilotFreStatus,
        userCopilotTabPinnedState,
        (_m = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _m === void 0 ? void 0 : _m.isStandaloneCopilotApp,
        officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload,
        isRoutedFromHwaAppsPage,
        navigateToHomePage,
        isBCAIS,
        isPinningEligible,
    ]);
    var logMetrics = function (eventName) {
        logAppHostMetrics({
            appId: copilotM365AppId,
            scenarioName: eventName,
            clientTimeStamp: appbarConnectorService.userClickTime,
            tileChanged: appbarConnectorService.tileChanged,
            appUrl: window.location.pathname,
            appSearchParams: window.location.search,
            isStandaloneApp: isStandaloneCopilotApp,
            resourceDeliveryType: appbarConnectorService.resourceDeliveryType,
        });
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        // skip this hook if we have already logged the event
        if (isOnCopilotAppPageRenderLogged) {
            return;
        }
        if (userCopilotTabPinnedState != null &&
            !!timeElapsedTillCopilotAppPageRender // i.e. has some value
        ) {
            logCopilotFunnelEvent('OnCopilotAppPageRender', {
                IsBCAISEnabled: (!!isBCAIS).toString(),
                IsPinningEligible: (!!isPinningEligible).toString(),
                EligibilityFinalStatus: (!!isEligibleForAnyCopilot).toString(),
                AdminPinningState: adminSetting.toString(),
                UserConsentState: userSetting.toString(),
                RedirectionSourceApp: getUserRedirectionSourceApp(),
                IsRedirectedUser: (getUserRedirectionSourceApp() !== '').toString(),
                CopilotWorkflowMode: (_c = (_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.copilot) === null || _b === void 0 ? void 0 : _b.mode) !== null && _c !== void 0 ? _c : '',
                IsCopilotPinned: userCopilotTabPinnedState.toString(),
                ElapsedTime: timeElapsedTillCopilotAppPageRender,
                Cohort: (_d = copilotEligibilityReasons === null || copilotEligibilityReasons === void 0 ? void 0 : copilotEligibilityReasons.cohort) !== null && _d !== void 0 ? _d : '',
                Persona: (_e = copilotEligibilityReasons === null || copilotEligibilityReasons === void 0 ? void 0 : copilotEligibilityReasons.persona) !== null && _e !== void 0 ? _e : '',
                AgeGroup: (_f = copilotEligibilityReasons === null || copilotEligibilityReasons === void 0 ? void 0 : copilotEligibilityReasons.ageGroup) !== null && _f !== void 0 ? _f : '',
                IsCodexEnabledRegion: (!!(copilotEligibilityReasons === null || copilotEligibilityReasons === void 0 ? void 0 : copilotEligibilityReasons.isCodexEnabledRegion)).toString(),
                IsOptedOutByAdmin: (!!(copilotEligibilityReasons === null || copilotEligibilityReasons === void 0 ? void 0 : copilotEligibilityReasons.isOptedOutByAdmin)).toString(),
                EduType: (_g = copilotEligibilityReasons === null || copilotEligibilityReasons === void 0 ? void 0 : copilotEligibilityReasons.eduType) !== null && _g !== void 0 ? _g : '',
            });
            setIsCopilotAppPageRenderLogged(true);
        }
    }, [
        adminSetting,
        (_p = (_o = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _o === void 0 ? void 0 : _o.copilot) === null || _p === void 0 ? void 0 : _p.mode,
        isBCAIS,
        isEligibleForAnyCopilot,
        copilotEligibilityReasons,
        isOnCopilotAppPageRenderLogged,
        isPinningEligible,
        timeElapsedTillCopilotAppPageRender,
        userCopilotTabPinnedState,
        userSetting,
    ]);
    var isShownCopilotFreRecently = useMemo(function () {
        if (userCopilotFreData === null || userCopilotFreData === void 0 ? void 0 : userCopilotFreData.LastCopilotFreDisplayTimestamp) {
            var timestamp = new Date(userCopilotFreData.LastCopilotFreDisplayTimestamp).getTime();
            var currentTime = new Date().getTime();
            return currentTime - timestamp < 1000 * 60; // 1 minute in milliseconds
        }
        return false;
    }, [userCopilotFreData === null || userCopilotFreData === void 0 ? void 0 : userCopilotFreData.LastCopilotFreDisplayTimestamp]);
    var shouldShowFreScreen = useCallback(function () {
        var _a;
        if (isRoutedFromHwaAppsPage()) {
            // In Desktop app, if user opens copilot from app gallery, don't show FRE screen
            return false;
        }
        if (!isCopilotFreEnabled ||
            !userCopilotFreData ||
            (userCopilotFreData === null || userCopilotFreData === void 0 ? void 0 : userCopilotFreData.ShouldShowWelcomeFre) == false ||
            userSetting !== CopilotUserPinningStatus.Default) {
            return false;
        }
        if (isBCAIS) {
            return isCopilotFreContinueSkuEnabled !== null && isCopilotFreContinueSkuEnabled !== void 0 ? isCopilotFreContinueSkuEnabled : false;
        }
        if ((((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.isStandaloneCopilotApp) &&
            isShownCopilotFreRecently) ||
            userCopilotTabPinnedState) {
            return false;
        }
        if (isPinningEligible) {
            return adminSetting != CopilotAdminPinningStatus.Unpinned;
        }
        return false;
    }, [
        adminSetting,
        isBCAIS,
        isCopilotFreContinueSkuEnabled,
        isCopilotFreEnabled,
        isPinningEligible,
        isShownCopilotFreRecently,
        userCopilotFreData,
        userCopilotTabPinnedState,
        (_q = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _q === void 0 ? void 0 : _q.isStandaloneCopilotApp,
        userSetting,
        isRoutedFromHwaAppsPage,
    ]);
    useEffect(function () {
        var _a, _b;
        // skip this hook if we have already logged the event
        if (isOnNoCopilotFRERenderLogged) {
            return;
        }
        // early return as data is not ready
        if (userCopilotFreData === undefined) {
            return;
        }
        if (shouldShowFreScreen() == false) {
            var FreNotShownReason = FreNotShownReasons.Unknown;
            if (!isCopilotFreEnabled) {
                FreNotShownReason = FreNotShownReasons.CopilotFreDisabled;
            }
            else if (((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.isStandaloneCopilotApp) &&
                isShownCopilotFreRecently) {
                FreNotShownReason = FreNotShownReasons.FreShownRecently;
            }
            else if (isPinningEligible &&
                adminSetting === CopilotAdminPinningStatus.Unpinned) {
                FreNotShownReason = FreNotShownReasons.AdminStatusIsUnPinned;
            }
            else if (userCopilotFreData.ShouldShowWelcomeFre == false) {
                FreNotShownReason =
                    FreNotShownReasons.FrePreviouslyShownAndActionTaken;
            }
            logCopilotFunnelEvent('OnNoCopilotFRERender', {
                IsOptinDialogShown: 'false',
                IsOnboardingDialogShown: 'false',
                PinAttempts: (_b = userCopilotFreData.PinFREShowCount.toString()) !== null && _b !== void 0 ? _b : '',
                userCopilotFreData: JSON.stringify(userCopilotFreData),
                FreNotShownReason: FreNotShownReason,
                CopilotTabPinnedState: userCopilotTabPinnedState.toString(),
            });
        }
        setNoCopilotFRERenderLogged(true);
    }, [
        adminSetting,
        isOnNoCopilotFRERenderLogged,
        isCopilotFreEnabled,
        isPinningEligible,
        isShownCopilotFreRecently,
        shouldShowFreScreen,
        userCopilotFreData,
        userCopilotTabPinnedState,
        (_r = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _r === void 0 ? void 0 : _r.isStandaloneCopilotApp,
    ]);
    var shouldShowCopilotTUI = useCallback(function (freStatus) {
        return (isStandaloneCopilotApp &&
            [CopilotFreStatus.Deferred, CopilotFreStatus.Declined].includes(freStatus) &&
            isShownCopilotFreRecently);
    }, [isShownCopilotFreRecently, isStandaloneCopilotApp]);
    useEffect(function () {
        var freStatus = userCopilotFreData === null || userCopilotFreData === void 0 ? void 0 : userCopilotFreData.CopilotFreStatus;
        updateShowCopilotTUI(shouldShowCopilotTUI(freStatus));
    }, [shouldShowCopilotTUI, updateShowCopilotTUI, userCopilotFreData]);
    useEffect(function () {
        var _a, _b;
        if (!userCopilotFreData) {
            return;
        }
        var shouldShow = shouldShowFreScreen();
        if (isFreScreenVisible === undefined) {
            if (shouldShow) {
                if ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.copilotPinningExperienceGates) === null || _b === void 0 ? void 0 : _b.copilotPinningExperienceEnabled) {
                    var copilotFreStatus = userCopilotFreData.CopilotFreStatus;
                    var renderPageCountBeforeFREAppearance = userCopilotFreData.RenderPageCountBeforeFREAppearance;
                    if (copilotFreStatus === CopilotFreStatus.Dismissed) {
                        setIsFreScreenVisible(false);
                    }
                    else if (copilotFreStatus === CopilotFreStatus.Default &&
                        renderPageCountBeforeFREAppearance < 3) {
                        setIsFreScreenVisible(false);
                        if (updatedCopilotRenderCounterOnce.current === false) {
                            updateUserPinningData({
                                RenderPageCountBeforeFREAppearance: renderPageCountBeforeFREAppearance + 1,
                            });
                        }
                        updatedCopilotRenderCounterOnce.current = true;
                    }
                    else {
                        setIsFreScreenVisible(true);
                    }
                }
                else {
                    setIsFreScreenVisible(true);
                }
            }
            else {
                setIsFreScreenVisible(false);
            }
        }
        updateHideTUI(shouldShow || isRedirectPending);
    }, [
        isFreScreenVisible,
        isRedirectPending,
        shouldShowFreScreen,
        updateHideTUI,
        userCopilotFreData,
        updateUserPinningData,
        featureGates,
    ]);
    useEffect(function () {
        if (currentRoute &&
            isMosRouteItem(currentRoute) &&
            currentRoute.appId &&
            currentRoute.appId === copilotM365AppId) {
            setRouteItem(currentRoute);
        }
    }, [currentRoute]);
    var eventNamesOnCopilotAppMount = function () {
        var eventNamesOnCopilotAppMount = [];
        if (!identity)
            eventNamesOnCopilotAppMount.push('CopilotAppStartIdentityMissing');
        if (!userEntitlements) {
            eventNamesOnCopilotAppMount.push('CopilotAppStartUserEntitlementsMissing');
        }
        else if (!(userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result)) {
            eventNamesOnCopilotAppMount.push('CopilotAppStartUserEntitlementsResultMissing');
        }
        if (!(featureGates === null || featureGates === void 0 ? void 0 : featureGates.result)) {
            eventNamesOnCopilotAppMount.push('CopilotAppStartFeatureGatesMissing');
        }
        if (!(featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result)) {
            eventNamesOnCopilotAppMount.push('CopilotAppStartFeatureSettingsMissing');
        }
        if (!routeItem) {
            eventNamesOnCopilotAppMount.push('CopilotAppStartRouteItemMissing');
        }
        else {
            if (!isMosRouteItem(routeItem)) {
                eventNamesOnCopilotAppMount.push('CopilotAppStartRouteItemNotMosRouteItem');
            }
            if (!routeItem.appId) {
                eventNamesOnCopilotAppMount.push('CopilotAppStartRouteItemAppIdMissing');
            }
            if (routeItem.appId !== copilotM365AppId) {
                eventNamesOnCopilotAppMount.push('CopilotAppStartRouteItemAppIdNotCopilotM365AppId');
            }
        }
        return eventNamesOnCopilotAppMount;
    };
    useEffect(function () {
        eventNamesOnCopilotAppMount().forEach(function (eventName) {
            logAppHostMetrics({
                appId: copilotM365AppId,
                scenarioName: eventName,
                clientTimeStamp: appbarConnectorService.userClickTime,
                tileChanged: appbarConnectorService.tileChanged,
                appUrl: window.location.pathname,
                appSearchParams: window.location.search,
                isStandaloneApp: isStandaloneCopilotApp,
                resourceDeliveryType: appbarConnectorService.resourceDeliveryType,
            });
        });
    }, []);
    useEffect(function () {
        function shouldThrottleUser() {
            var _a, _b, _c, _d;
            if (!isStandaloneCopilotApp) {
                return false;
            }
            var regionThrottlingPercent = parseInt(((_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.copilot) === null || _b === void 0 ? void 0 : _b.regionThrottlingPercent) || '');
            if (isNaN(regionThrottlingPercent)) {
                return false;
            }
            // Get randomInt and timestamp from sessionStorage
            var randomInt = parseInt(window.sessionStorage.getItem(Copilot_Throttling_Number_Key) ||
                '');
            var storedTimestampMillisec = parseInt(window.sessionStorage.getItem(Copilot_Throttling_Timestamp_Key) || '');
            var currentTimeMillisec = Date.now();
            var throttlingIntervalInMins = parseInt(((_d = (_c = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _c === void 0 ? void 0 : _c.copilot) === null || _d === void 0 ? void 0 : _d.throttlingIntervalInMins) ||
                '');
            // Fallback to 10 minutes if the throttling interval is not a valid number
            if (isNaN(throttlingIntervalInMins)) {
                throttlingIntervalInMins = 10;
            }
            if (isNaN(randomInt) ||
                isNaN(storedTimestampMillisec) ||
                currentTimeMillisec - storedTimestampMillisec >
                    throttlingIntervalInMins * 60 * 1000 // check if the time difference exceeds the set or fallback interval (in minutes)
            ) {
                // generate new randomInt between 0 and 99, both inclusive
                randomInt = Math.floor(Math.random() * 100);
                // store randomInt and timestamp
                window.sessionStorage.setItem(Copilot_Throttling_Number_Key, randomInt.toString());
                window.sessionStorage.setItem(Copilot_Throttling_Timestamp_Key, currentTimeMillisec.toString());
            }
            if (randomInt < regionThrottlingPercent) {
                logCopilotFunnelEvent('CopilotThrottlingPageShown', {});
                return true;
            }
            else {
                return false;
            }
        }
        var shouldThrottle = shouldThrottleUser();
        setThrottleUser(shouldThrottle);
    }, [
        (_t = (_s = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _s === void 0 ? void 0 : _s.copilot) === null || _t === void 0 ? void 0 : _t.regionThrottlingPercent,
        (_v = (_u = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _u === void 0 ? void 0 : _u.copilot) === null || _v === void 0 ? void 0 : _v.throttlingIntervalInMins,
        isStandaloneCopilotApp,
    ]);
    var firstRenderSpinnerRef = useRef(true);
    if (!identity ||
        !userEntitlements ||
        !userEntitlements.result ||
        !(featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) ||
        throttleUser === undefined) {
        return null;
    }
    if (!routeItem ||
        !isMosRouteItem(routeItem) ||
        !routeItem.appId ||
        routeItem.appId !== copilotM365AppId) {
        return null;
    }
    if (copilotM365AppId !== loggedAppIdRef.current) {
        if (!appbarConnectorService.tileChanged) {
            var entries = performance.getEntriesByType('navigation');
            if (entries &&
                entries.length > 0 &&
                entries[0].responseEnd &&
                entries[0].responseEnd >= 0) {
                var responseEnd = entries[0].responseEnd;
                var domainLookupStart = entries[0].domainLookupStart;
                logAppHostMetricsWithMsgDelay(copilotM365AppId, 'PageFetchTimeFromServer', Math.round(responseEnd), appbarConnectorService.tileChanged, window.location.pathname, entries[0].redirectCount, isStandaloneCopilotApp, window.location.search, appbarConnectorService.resourceDeliveryType, (_w = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _w === void 0 ? void 0 : _w.IsGovernment);
                if (domainLookupStart >= 0) {
                    logAppHostMetricsWithMsgDelay(copilotM365AppId, 'PageFetchTimeFromServerExcludeRedirection', Math.round(responseEnd - domainLookupStart), appbarConnectorService.tileChanged, window.location.pathname, entries[0].redirectCount, isStandaloneCopilotApp, window.location.search, appbarConnectorService.resourceDeliveryType, (_x = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _x === void 0 ? void 0 : _x.IsGovernment);
                }
            }
        }
        else {
            logAppHostMetricsWithMsgDelay(copilotM365AppId, 'PageFetchTimeFromServer', 0, appbarConnectorService.tileChanged, window.location.pathname, undefined, isStandaloneCopilotApp, window.location.search, appbarConnectorService.resourceDeliveryType, (_y = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _y === void 0 ? void 0 : _y.IsGovernment);
        }
        logAppHostMetrics({
            appId: copilotM365AppId,
            scenarioName: 'CopilotAppPageEnd',
            clientTimeStamp: appbarConnectorService.userClickTime,
            tileChanged: appbarConnectorService.tileChanged,
            appUrl: window.location.pathname,
            appSearchParams: window.location.search,
            isStandaloneApp: isStandaloneCopilotApp,
            resourceDeliveryType: appbarConnectorService.resourceDeliveryType,
        });
        if (appbarConnectorService.userClickTime) {
            var timeElapsed_1 = Date.now() - appbarConnectorService.userClickTime;
            // This helps to avoid potential issues with synchronous state updates
            setTimeout(function () {
                setTimeElapsedTillCopilotAppPageRender(timeElapsed_1.toString());
            }, 0);
        }
        loggedAppIdRef.current = copilotM365AppId;
    }
    function onCopilotFreCompleted(response) {
        var _a, _b;
        setIsCopilotFreCompleted(true);
        updateShowCopilotTUI(shouldShowCopilotTUI(response));
        var copilotRedirectControlEnabled = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.copilotGates) === null || _b === void 0 ? void 0 : _b.copilotRedirectControlEnabled;
        // TODO: Uncomment, after testing the Ask Later scenarion on CCM
        // the timestamp is maintained in common state and not needed to update here anymore
        // setUserCopilotFreData((prevData) => {
        //     if (!prevData) {
        //         return prevData;
        //     }
        //     return {
        //         ...prevData,
        //         LastCopilotFreDisplayTimestamp: new Date().toISOString(),
        //     };
        // });
        switch (response) {
            case CopilotFreStatus.Accepted:
                if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) !== OfficeWorkload.Hwa) {
                    setIsRedirectPending(routeToOCDIChat(isStandaloneCopilotApp, copilotBaseUrlm365Redirecttion, identity, copilotRedirectControlEnabled));
                }
                break;
            case CopilotFreStatus.Deferred:
                if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) !== OfficeWorkload.Hwa) {
                    setIsRedirectPending(routeToCopilotStandalone(isStandaloneCopilotApp, copilotBaseUrlccmRedirecttion, identity));
                }
                else {
                    navigateToHomePage();
                }
                break;
            case CopilotFreStatus.Declined:
                if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) !== OfficeWorkload.Hwa) {
                    setIsRedirectPending(routeToCopilotStandalone(isStandaloneCopilotApp, copilotBaseUrlccmRedirecttion, identity));
                }
                else {
                    navigateToHomePage();
                }
                break;
            case CopilotFreStatus.Continue:
                if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) !== OfficeWorkload.Hwa) {
                    setIsRedirectPending(routeToOCDIChat(isStandaloneCopilotApp, copilotBaseUrlm365Redirecttion, identity, copilotRedirectControlEnabled));
                }
                break;
            default:
                break;
        }
        setIsFreScreenVisible(false);
    }
    function getUserRedirectionSourceApp() {
        var _a;
        var urlSearchParams = new URLSearchParams(location.search);
        return ((_a = urlSearchParams.get(CopilotRedirectionQueryParams.fromCode)) !== null && _a !== void 0 ? _a : '');
    }
    var shouldShowComingSoon = !((_z = featureGates.result.copilotGates) === null || _z === void 0 ? void 0 : _z.copilotClientExperienceEnabled) ||
        identity.isMsa ||
        !isEligibleForAnyCopilot;
    var appHostCommonComponent = function (_a) {
        var _b;
        var userCopilotTabPinnedState = _a.userCopilotTabPinnedState, routeItem = _a.routeItem;
        return (React.createElement(React.Fragment, null,
            React.createElement(OCDIBannerAnnouncementWrapper, { userCopilotLicensed: userCopilotTabPinnedState }),
            React.createElement(AppHostComponent, { appbarConnectorService: AppbarConnectorService.getInstance(), appId: (_b = routeItem.appId) !== null && _b !== void 0 ? _b : '', entityId: routeItem.entityId, subPageId: routeItem.subPageId, key: "".concat(routeItem.appId, "_").concat(routeItem.entityId) }),
            React.createElement(TeachingUiContainer, { scrollContentRef: createRef() })));
    };
    var appHostPage = !isStandaloneCopilotApp ? (React.createElement(PageUnstyled, { errorEventName: "M365Apps", name: "M365Apps" }, appHostCommonComponent({
        userCopilotTabPinnedState: userCopilotTabPinnedState,
        routeItem: routeItem,
    }))) : (React.createElement(PageUnstyled, { errorEventName: "M365Apps", name: "M365Apps" },
        React.createElement("div", { className: styles.copilotSection }, appHostCommonComponent({
            userCopilotTabPinnedState: userCopilotTabPinnedState,
            routeItem: routeItem,
        }))));
    var renderContent = function () {
        var _a;
        if (isFreScreenVisible === undefined || isRedirectPending) {
            if (firstRenderSpinnerRef.current) {
                logAppHostMetrics({
                    appId: copilotM365AppId,
                    scenarioName: 'CopilotAppPageSpinnerRendered',
                    clientTimeStamp: appbarConnectorService.userClickTime,
                    tileChanged: appbarConnectorService.tileChanged,
                    appUrl: window.location.pathname,
                    appSearchParams: window.location.search,
                    isStandaloneApp: isStandaloneCopilotApp,
                    resourceDeliveryType: appbarConnectorService.resourceDeliveryType,
                });
                firstRenderSpinnerRef.current = false;
            }
            return (React.createElement("div", { className: styles.spinnerContainer },
                React.createElement(Spinner, { label: (_a = locStrings === null || locStrings === void 0 ? void 0 : locStrings.metaOSHubResources) === null || _a === void 0 ? void 0 : _a.loadingLabel, size: "small", labelPosition: "below" })));
        }
        if (isFreScreenVisible) {
            return (React.createElement(PageUnstyled, { errorEventName: "CopilotFre", name: "CopilotFre" },
                React.createElement(CopilotFreLazyBoundary, { onCopilotFreCompleted: onCopilotFreCompleted, 
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    userEntitlements: userEntitlements.result, 
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    userPinningData: userCopilotFreData })));
        }
        return appHostPage;
    };
    if (showModeBExperience) {
        if (throttleUser) {
            handleResumeScheduling();
            return React.createElement(CopilotNotAvailableLazyBoundary, null);
        }
        if (identity.isMsa) {
            return (React.createElement(MsaModeBComponentLazyBoundary, { cmcDefaultBaseUrl: cmcBaseUrlDefault, userPrincipalName: (_0 = identity.userPrincipalName) !== null && _0 !== void 0 ? _0 : '' }));
        }
        else {
            if ((_2 = (_1 = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _1 === void 0 ? void 0 : _1.copilotGates) === null || _2 === void 0 ? void 0 : _2.copilotComingSoonForIneligibleUsersEnabled) {
                if (!isBCAIS && !isEligibleForAnyCopilot) {
                    // this is OrgID user, and is not eligible for any copilot experience
                    // so show Coming Soon page
                    if (isOnCopilotModeBComingSoonLoggedRef.current === false) {
                        logCopilotFunnelEvent('CopilotModeBComingSoon', {});
                        isOnCopilotModeBComingSoonLoggedRef.current = true;
                    }
                    return React.createElement(ComingSoonControlLazyBoundary, null);
                }
            }
            return renderContent();
        }
    }
    else {
        // Mode A Experience
        if (shouldShowComingSoon || isStandaloneCopilotApp) {
            if (isOnCopilotModeAComingSoonLoggedRef.current === false) {
                logCopilotFunnelEvent('CopilotModeAComingSoon', {});
                isOnCopilotModeAComingSoonLoggedRef.current = true;
            }
            return React.createElement(ComingSoonControlLazyBoundary, null);
        }
        else {
            return appHostPage;
        }
    }
};
//# sourceMappingURL=CopilotAppPage.js.map